<template>
  <div class="app" :class="{ 'blurred': isBlurred }">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none ml-1" display="md" mobile />
      <SidebarToggler class="d-md-down-none ml-1" display="lg"/>
      <b-link class="navbar-brand" to="/">
        <h1><img class="navbar-brand-full" src="https://storage.googleapis.com/protopia/logos/logo_protopia_white_m.png" width="125" alt="Protopia Logo"></h1>
      </b-link>
      <b-navbar-nav class="d-md-down-none ml-auto">
          <div class="mr-3 d-flex align-items-center" v-if="selectedCommunity && selectedCommunity !== 'all'">
              <span class="navbar-text mr-3 font-weight-bold text-white" v-if="selectedCommunityName">{{ selectedCommunityName }}</span>
              <b-button v-if="communityList.length > 1" variant="outline-light" size="sm" @click="openWelcomeModal">Change Community</b-button>
          </div>
          <div v-if="isPriority">
               <c-switch color="success" title="Priority Reports" v-on:change="changeStatus(),setAttributesToCswitch()" name="downloadReportPriority" v-model="userData.download_report_priority" label variant="pill" size="sm" class="float-right download-priority-report-switch"/>
          </div>
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdown :auth="auth" :authenticated="authenticated"/>
        </b-nav-item>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="navItems" ref="sidebarNav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main dashboard-main">
          <div class="breadcrumb-top">
                <!-- Custom breadcrumb -->
                <ol class="breadcrumb" style="min-height: 55px; display: flex; align-items: center;">
                    <li
                        v-for="(routeObject, index) in list"
                        :key="index"
                        class="breadcrumb-item"
                        :class="{ active: index === list.length - 1 }"
                    >
                        <span v-if="index === list.length - 1">
                            {{ (routeObject.meta && routeObject.meta.label) || routeObject.name }}
                        </span>
                        <a
                            v-else
                            href="#"
                            style="cursor: pointer;"
                            @click.prevent="onBreadcrumbClick(routeObject)"
                        >
                            {{ (routeObject.meta && routeObject.meta.label) || routeObject.name }}
                        </a>
                    </li>
                </ol>
                <!-- v-if="$route.name && ($route.name == 'Dashboard' || $route.name == 'Community Information')" -->
                <div class="form-search" style="display: flex; justify-content: flex-end; align-items: center;">
                    <!-- <router-link to='/dashboard/advanced-search' class="adv-search-label">
                    Advanced Search
                </router-link> -->
                <span v-if="selectedCommunity != 'all' && ($route.path === '/dashboard' || $route.path.includes('/dashboard/communities')) && circles.length > 0" style="margin-right: 10px;">Circle:</span>
                <b-form-select v-if="selectedCommunity != 'all' && ($route.path === '/dashboard' || $route.path.includes('/dashboard/communities')) && circles.length > 0 " v-model="selectedCircle" class="custom-card-header-filter" @change="filterByCircle" style="margin-right: 10px; min-width: 100px; max-width: 100%; width: auto; display: inline-block;">
                    <!-- <option :value="null" selected disabled>Circle</option> -->
                    <option value="all">All</option>
                    <option v-for="circle in circles" :key="circle._id" :value="circle._id">{{ circle.name }}</option>
                </b-form-select>
                <datepicker v-if="$route.path === '/dashboard' || $route.path.includes('/dashboard/communities')" @changed="dateFilter" :value="defaultDateRange" label="Date Range" style="margin-right: 10px;"></datepicker>
                <b-form v-on:submit.prevent="searchData">
                    <b-form-group label-for="elementsTwoButtons" class="mb-0">
                            <b-input-group>
                                <b-form-input aria-label="Searchbar" v-model="searchTxt" name="search" type="text" @input="searchTxt = sanitizeInput($event)"></b-form-input>
                                <b-input-group-append>
                                    <b-button type="submit" aria-label="Search"><i class="fa fa-search"></i></b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-form>
                    <div tabindex="0" role="button" class="adv-search-label tab-focus" @click="openAdvancedSearchModal()">
                        Advanced Search
                    </div>
                </div>
          </div>
          <b-modal id="advanced-search-modal" class="advanced-search-modal" size="md" v-model="advancedSearchModal" ok-title="Close" @ok="advancedSearchModal = false" title="Advanced Search">
              <b-card-body>
                  <b-form>
                        <b-form-group label="Communties:" label-for="communities">
                            <li class="list-inline-item w-100">
                                <b-form-select v-model="search.community">
                                    <option :value="null" selected disabled>Community</option>
                                    <option value="all">All</option>
                                    <option v-for="community in allCommunities" :key="community._id" :value="community._id">{{community.name}}</option>
                                </b-form-select>
                            </li>
                        </b-form-group>
                      <b-form-group label="Organization:" label-for="organization">
                          <b-form-input type="text" v-on:keyup="handleBlur" name="organization" v-model="search.organization" placeholder="Enter organization" @input="search.organization = sanitizeInput($event)"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Title:" label-for="title">
                          <b-form-input type="text" v-on:keyup="handleBlur" name="title" v-model="search.title" placeholder="Enter title" @input="search.title = sanitizeInput($event)"></b-form-input>
                      </b-form-group>
                      <b-form-group label="City:" label-for="city">
                          <b-form-input type="text" v-on:keyup="handleBlur" name="city" v-model="search.city" placeholder="Enter city" @input="search.city = sanitizeInput($event)"></b-form-input>
                      </b-form-group>
                      <b-form-group label="State:" label-for="state">
                          <b-form-input type="text" v-on:keyup="handleBlur" name="state" v-model="search.state" placeholder="Enter state" @input="search.state = sanitizeInput($event)"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Country:" label-for="country">
                          <b-form-input type="text" v-on:keyup="handleBlur" name="country" v-model="search.country" placeholder="Enter country" @input="search.country = sanitizeInput($event)"></b-form-input>
                      </b-form-group>
                      <b-form-group label="School:" label-for="school">
                          <b-form-input type="text" v-on:keyup="handleBlur" name="school" v-model="search.school" placeholder="Enter school" @input="search.school = sanitizeInput($event)"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Major:" label-for="major">
                          <b-form-input type="text" v-on:keyup="handleBlur" name="major" v-model="search.major" placeholder="Enter major" @input="search.major = sanitizeInput($event)"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Year:" label-for="year">
                          <b-form-input type="text" v-on:keyup="handleBlur" name="year" v-model="search.year" placeholder="Enter year" @input="search.year = sanitizeInput($event)"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Property ID:" label-for="propertyid">
                          <b-form-input type="text" v-on:keyup="handleBlur" name="propertyid" v-model="search.propertyId" placeholder="Enter property ID" @input="search.propertyId = sanitizeInput($event)"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Member Tags:" label-for="member_rank">
                          <b-form-input type="text" v-on:keyup="handleBlur" name="member_rank" v-model="search.member_rank" placeholder="Enter member rank" @input="search.member_rank = sanitizeInput($event)"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Member Type:" label-for="member_type">
                          <b-form-input type="text" v-on:keyup="handleBlur" name="member_type" v-model="search.member_type" placeholder="Enter member type" @input="search.member_type = sanitizeInput($event)"></b-form-input>
                      </b-form-group>
                      <div class="form-group">
                          <!-- class="d-block" -->
                          <label for="skill">Skill:</label>
                          <img tabindex="0" src="img/tooltip.png" v-b-tooltip.right title='To find members for multiple skills, enter values comma-separated (e.g., "marketing, design, communication" will return all members that match at least one of those values).' class="skill-info" height="12" alt="tooltip" v-bind:aria-live="isMozilla() ? 'polite' : null" />
                          <div class="bv-no-focus-ring">
                              <input id="skill" name="skill" type="text" v-on:keyup="handleBlur" v-model="search.skill" placeholder="Enter skill" class="form-control" @input="e => search.skill = sanitizeInput(e.target.value)">
                          </div>
                      </div>
                      <div class="form-group">
                          <!-- class="d-block" -->
                          <label for="interests">Interests:</label>
                          <img tabindex="0" src="img/tooltip.png" v-b-tooltip.right title='To find members for multiple interests, entering comma-separated values (e.g. "marketing, design, communication") will return all members that match at least one of those values.' class="skill-info" height="12" alt="tooltip" />
                          <div class="bv-no-focus-ring">
                              <input id="interests" name="interests" type="text" v-on:keyup="handleBlur" v-model="search.interests" placeholder="Enter interests" class="form-control" @input="e => search.interests = sanitizeInput(e.target.value)">
                          </div>
                      </div>
                      <ul class="list-inline">
                          <li class="list-inline-item">
                              <button type="button" class="btn custom-card-header-filter btn-dropbox tab-focus" @click="advancedSearch()" :disabled="isBtnDisabled">
                                  Search
                              </button>
                          </li>
                          <li class="list-inline-item">
                              <button type="button" class="btn custom-card-header-filter btn-cancel tab-focus" @click="clearSearch()">Clear</button>
                          </li>
                      </ul>
                  </b-form>
              </b-card-body>
                <template #modal-footer="{ cancel }">
                    <div>
                        <button class="btn custom-card-header-filter btn-primary tab-focus custom-close-button" @click="cancel()">Close</button>
                    </div>
                </template>
          </b-modal>
        <div class="container-fluid">
          <keep-alive include="dashboard">
            <router-view></router-view>
          </keep-alive>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a :href="protopiaurl">Protopia</a>
      </div>
    </TheFooter>
    <WelcomeModal />
  </div>
</template>
<script>
import nav from '@/_nav'
import { Header as AppHeader, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'
import axios from "axios";
import { Switch as cSwitch } from '@coreui/vue';
import VueNotifications from 'vue-notifications';
import SidebarToggler from '../components/Sidebar/SidebarToggler';
import datepicker from '../views/engagement/components/datePicker';
import EventBus from '../assets/js/EventBus';
import { lastNDaysStart } from '../assets/js/common';
import { sanitizeInput, sanitizeUrl, sanitizeHtmlTemplate, sanitizeResourceDescription } from '../utils/sanitizer';
import WelcomeModal from '../components/WelcomeModal';
export default {
  name: 'DefaultContainer',
  props: ["auth", "authenticated"],
  components: {
    SidebarToggler,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    DefaultAside,
    DefaultHeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    cSwitch,
    datepicker,
    WelcomeModal
  },
  data () {
    const currentDate = new Date();
    const startDate = lastNDaysStart(30, currentDate);
    return {
      // Counter bumped via EventBus.'breadcrumb:refresh' so the `list`
      // computed re-evaluates after a child view mutates a matched
      // route's name (e.g. OpportunityDetail injecting the job title).
      // Without a reactive dep here the computed cache is never busted.
      bcVersion: 0,
      navItems: [],
      // Recruiting module flag for the currently-selected community. Toggled
      // in loadSelectedCommunityData; buildSidebarMenu uses it to include or
      // exclude the "Opportunities" sidebar entry.
      recruitingEnabled: false,
      communityData: {},
      settingData: {},
    //   askAPeerBtn: {},
      reportData: {},
      userData: {},
      authUser: null,
      token: null,
      protopiaurl: process.env.VUE_APP_API_PROTOPIA_URL,
      isPriority: false,
      searchTxt: '',
      advancedSearchModal: false,
      search: {},
      isBtnDisabled: true,
      allCommunities: '',
      circles: [],
      selectedCommunity:'all',
      selectedCircle: 'all',
      circleId: null,
      selectedDates: {startDate: startDate, endDate: currentDate},
      defaultDateRange: 'last-30',
      isBlurred: false,
      communityList: [],
            selectedCommunityName: '',
            sidebarViewportCleanupHandler: null,
            isMobileViewport: null,
            wasSidebarMinimizedBeforeMobile: false
    }
  },
  notifications: {
      showErrorMsg: {
          message: 'Search text should be greater than 2.',
          type: VueNotifications.types.error
      }
  },
  watch: {
    "$route": "updateCommunityForAdvancedSearch",
    $route(to, from) {
        this.handleUrlChange();
    },
    selectedCommunity(newVal) {
        if(newVal === 'all') {
            this.selectedCircle = 'all';
        }
        EventBus.$emit('communityChanged', newVal);
    },
    "$route.params.community_id": function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
            // Reset circles immediately to prevent cross-contamination before state change triggers
            this.selectedCircle = 'all';
            this.circles = [];
            
            this.selectedCommunity = newVal;
            this.handleCommunitySelection(newVal);
            EventBus.$emit('communityChanged', newVal);
        }
    },
    // selectedCircle(newVal) {
    //     EventBus.$emit('circleChanged', { circle: newVal, community: this.selectedCommunity });
    // },
    selectedDates: {
        handler(newVal) {
        EventBus.$emit('dateChanged', newVal);
        },
        deep: true
    }
  },
  async created() {
    window.USETIFUL_TOKEN = process.env.VUE_APP_USETIFUL_KEY;
    this.token = localStorage.getItem('token');
    this.authUser = JSON.parse(localStorage.getItem('authUser'));
    
    EventBus.$on('resetFilters', this.resetFilters);
    EventBus.$on('breadcrumb:refresh', () => { this.bcVersion++; });
    
    // Listen for the event from WelcomeModal
    this.$root.$on('community-selected', this.handleCommunitySelection);
    this.$root.$on('toggle-blur', (val) => {
        this.isBlurred = val;
    });
    
    // Fetch community list from tenants
    await this.fetchCommunityList();
    
    // Check if we have a selected community in localStorage
    const savedCommunity = localStorage.getItem('user_modal_option');
    if (savedCommunity && this.selectedCommunity !== savedCommunity) {
        this.selectedCommunity = savedCommunity;
        this.updateCommunityNameFromList(savedCommunity);
        await this.loadSelectedCommunityData(savedCommunity);
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
        // Read the breadcrumb-refresh counter so this computed
        // re-evaluates when a child view emits 'breadcrumb:refresh'.
        // eslint-disable-next-line no-unused-expressions
        this.bcVersion;
        this.searchTxt = '';
        if (this.$route.params.slug == 'email_open') {
            this.$route.matched[1].name = 'Email Open Rate On Requests';
        } else if (this.$route.params.slug == 'engagement_rate') {
            this.$route.matched[1].name = 'Engagement Rate';
        } else if (this.$route.params.slug == 'first_response') {
            this.$route.matched[1].name = 'Time To First Response';
        }  else if (this.$route.params.slug == 'response_per_request') {
            this.$route.matched[1].name = 'Responses Per Request';
        } else if (this.$route.params.slug == 'satisfaction') {
            this.$route.matched[1].name = 'Average Satisfaction';
        } else if (this.$route.params.slug == 'profile_update') {
            this.$route.matched[1].name = 'Profile Updates';
        }
        return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  mounted() {
    this.handleUrlChange();
        this.handleSidebarViewportChange();

        this.sidebarViewportCleanupHandler = () => {
            this.handleSidebarViewportChange();
        };
        window.addEventListener('resize', this.sidebarViewportCleanupHandler, { passive: true });
        window.addEventListener('orientationchange', this.sidebarViewportCleanupHandler);

    const targetNode = this.$el.querySelector('ul.nav');
    const config = { attributes: true, attributeFilter: ['class'], childList: true, subtree: true };
    const callback = (mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            this.setNavItemsTabindex();
        }
        // } else if (mutation.type === 'childList') {
        // }
      }
    };
    this.observer = new MutationObserver(callback);
    this.observer.observe(targetNode, config);
    targetNode.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            const focusedElement = document.activeElement;
            focusedElement.click();
        }
    });
    document.getElementsByClassName('sidebar-minimizer')[0].setAttribute("tabindex", "0");
    const toastr_notification = document.getElementById("mini-toastr");
    toastr_notification.setAttribute('aria-live', 'assertive');

        // Enable wheel scroll only for the collapsed sidebar flyout list.
        this.collapsedSidebarWheelHandler = (e) => {
            if (!document.body.classList.contains('sidebar-minimized')) {
                return;
            }

            const dropdownItems = e.target.closest('.sidebar-minimized .sidebar .nav-dropdown-items');
            if (!dropdownItems) {
                return;
            }

            const maxScrollTop = dropdownItems.scrollHeight - dropdownItems.clientHeight;
            if (maxScrollTop <= 0) {
                return;
            }

            const delta = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY;
            const nextScrollTop = Math.max(0, Math.min(maxScrollTop, dropdownItems.scrollTop + delta));
            if (nextScrollTop === dropdownItems.scrollTop) {
                return;
            }

            // Keep wheel scrolling inside flyout when collapsed.
            e.preventDefault();
            e.stopPropagation();
            dropdownItems.scrollTop = nextScrollTop;
        };

        this.collapsedSidebarWheelTarget = this.$el.querySelector('.sidebar');
        if (this.collapsedSidebarWheelTarget) {
            this.collapsedSidebarWheelTarget.addEventListener('wheel', this.collapsedSidebarWheelHandler, { passive: false, capture: true });
        } else {
            document.addEventListener('wheel', this.collapsedSidebarWheelHandler, { passive: false, capture: true });
        }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
        if (this.sidebarViewportCleanupHandler) {
            window.removeEventListener('resize', this.sidebarViewportCleanupHandler);
            window.removeEventListener('orientationchange', this.sidebarViewportCleanupHandler);
            this.sidebarViewportCleanupHandler = null;
        }
        if (this.collapsedSidebarWheelHandler) {
            if (this.collapsedSidebarWheelTarget) {
                this.collapsedSidebarWheelTarget.removeEventListener('wheel', this.collapsedSidebarWheelHandler, true);
            }
            document.removeEventListener('wheel', this.collapsedSidebarWheelHandler, true);
            this.collapsedSidebarWheelHandler = null;
            this.collapsedSidebarWheelTarget = null;
        }
  },
  methods: {
    onBreadcrumbClick(routeObject) {
      // Follow the record's redirect if set (Home = '/' → '/dashboard'); otherwise push its path.
      const target = typeof routeObject.redirect === 'string' ? routeObject.redirect : routeObject.path
      this.$router.push(target)
    },
    handleSidebarViewportChange() {
        const isMobileNow = window.matchMedia('(max-width: 991.98px)').matches;
        if (this.isMobileViewport === isMobileNow) {
            return;
        }

        this.isMobileViewport = isMobileNow;
        const bodyClasses = document.body.classList;

        if (isMobileNow) {
            if (bodyClasses.contains('sidebar-minimized')) {
                this.wasSidebarMinimizedBeforeMobile = true;
                bodyClasses.remove('sidebar-minimized');
            }

            // Ensure desktop sidebar visibility classes do not bleed into mobile layout.
            bodyClasses.remove('sidebar-sm-show', 'sidebar-md-show', 'sidebar-lg-show', 'sidebar-xl-show');
        } else if (this.wasSidebarMinimizedBeforeMobile) {
            bodyClasses.add('sidebar-minimized');
            this.wasSidebarMinimizedBeforeMobile = false;
        }

        this.$nextTick(() => {
            this.setNavItemsTabindex();
        });
    },
    async loadData() {
        this.search = this.$route.query;
        this.updateCommunityForAdvancedSearch();
        this.handleBlur();
        this.communityData = {};
        
        // If we have a selected community, load only that one
        if (this.selectedCommunity && this.selectedCommunity !== 'all') {
            await this.loadSelectedCommunityData(this.selectedCommunity);
            return;
        }

        var fetchCommunity = '';
        // check navbar has a community data then skip this iteration
        var communityexists = nav.items.filter(item => item.name === 'Communities');
        if (communityexists.length) {
            var communityIndex = nav.items.findIndex(item => item.name === 'Communities');
            nav.items.splice(communityIndex, 1);
        }
        // display communities role wise
        
        if (this.authUser && !this.selectedCommunity) {
             console.log("Waiting for community selection...");
        }
        
        this.communityData = { name: 'Communities', icon: 'icon-globe', children: [],url: '#'};
        nav.items.push(this.communityData);

        if (this.authUser) {
            // this.reportData = {
            //      name: 'Reports', icon: 'cui-dashboard',url: '/reports',
                //  children: [
                //     {
                //         name: 'Interaction', url: '/reports/engagement-detail', icon: ''
                //     },
                //     {
                //         name: 'Opt-out Report', url: '/reports/member-opt-out', icon: ''
                //     },
                //     {
                //         name: 'Overdue Requests', url: '/reports/overdue-request', icon: ''
                //     },
                //     {
                //         name: 'Invalid Emails', url: '/reports/invalid-emails', icon: ''
                //     },
                //     {
                //         name: 'No Follow Up', url: '/reports/no-follow-up', icon: ''
                //     },
                //     {
                //         name: 'Donor Engagement', url: '/reports/donor-engagement', icon: ''
                //     }
                // ]
            // };
        // this.navItems.push(this.reportData);
        this.settingData = { name: 'Settings', icon: 'cui-cog',url: '#', children: [{
            name: 'Member Rank', url: '/reports/member-rank', icon: ''
        }, {
            name: 'Scoring Model', url: '/dashboard/engagement-score',icon: ''
        }, {
            name: 'Users', url: '/dashboard/users',icon: ''
        }]};

        // this.askAPeerBtn = {name: "Ask A Peer", url: "https://ask.protopia.co/peers", class: "btn ask-a-peer-btn", target:  "_blank", attributes: { target: '_blank'}};
        // this.navItems.push(this.askAPeerBtn);
        this.navItems.push(this.settingData);
    }
      this.navItems = [...this.navItems].concat(nav.items);
        const isSuperAdmin = this.authUser.role === 'SuperAdmin';
        var navItem = [];
        navItem.push(nav.items[0]); //dashboard
        navItem.push(this.communityData);
        navItem.push(nav.items[3]); //Engagement
        navItem.push(nav.items[4]); //Management
        navItem.push(nav.items[5]); // Members
        // SCRUM-645's SuperAdmin-only restriction is lifted — the Engagement Stream vs
        // Responses count discrepancy it was guarding against has been fixed.
        navItem.push(nav.items[1]); // Stream
        navItem.push(nav.items[2]); //reports
        navItem.push(nav.items[8]); // Resources
        navItem.push(nav.items[6]); //Library
        navItem.push(nav.items[7]); // uploads
        if (isSuperAdmin) {
          navItem.push(this.settingData); //settings[children{Scoring Model,Users}]
        }
        this.navItems = navItem;
        this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/users/${this.authUser._id}/edit-profile`, {headers: {'x-access-token': this.token}}).then(response => {
            if(response.data.user) {
                this.userData = response.data.user;
                if (this.userData.role == 'SuperAdmin') {
                    this.isPriority = true;
                }
            }
        }).catch(err => {
            if (err.response.status === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
            }
        });
        this.setNavItemsTabindex();
    },
    isMozilla() {
      return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    },
    async getCommunities() {
        try {
            const response = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/filter-community`, { headers: { 'x-access-token': this.token } });
            if (response.status === 200 && Array.isArray(response.data)) {
                this.allCommunities = response.data;
            }
        } catch (error) {
            console.error('Error fetching communities:', error);
            if (error.response && error.response.status === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
            }
        }
        this.filterByCommunity();
    },
    async filterByCommunity() {
        console.log("selectedCommunity:",this.selectedCommunity);
        this.selectedCircle = "all";
        if (this.selectedCommunity === "all") {
            this.circles = [];
            this.loadData();
        } else {
            const selectedCommunity = this.allCommunities.find(c => c._id === this.selectedCommunity);
            this.circles = selectedCommunity ? selectedCommunity.additionalParams : [];
            this.circles = this.circles
                .filter(circle => circle && circle.name)
                .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            console.log("circles:",this.circles);
            this.loadData();
        }

    },
    dateFilter(res) {
        this.selectedDates = res;
        this.selectedTimeframe = res.selectedValue === null ? 'all' : (res.selectedValue || 'last-30');
        this.defaultDateRange = res.selectedValue !== undefined ? res.selectedValue : 'last-30';
        this.loadData();
    },
    async filterByCircle() {
        if(this.selectedCircle === 'all'){
            this.selectedCircle = 'all';
            this.circleShortName = 'all';
            EventBus.$emit('circleChanged', { circle: this.selectedCircle, circleShortName: this.circleShortName, community: this.selectedCommunity });
        }
        const selectedCircleObject = this.circles.find(circle => circle._id === this.selectedCircle);
    if (selectedCircleObject) {
        this.circleShortName = selectedCircleObject.short;
        this.selectedCircle = selectedCircleObject._id;
            EventBus.$emit('circleChanged', { circle: this.selectedCircle, circleShortName: this.circleShortName, community: this.selectedCommunity });
        }
        // try {
        //     let url;
        //     if (this.selectedCircle === "all") {
        //         url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/community/${this.selectedCommunity}/resources`;
        //     } else {
        //         url = `${process.env.VUE_APP_API_BASE_URL}/dashboard/community/${this.selectedCommunity}/resources?circle=${this.selectedCircle}`;
        //     }
        //     const response = await this.axios.get(url, { headers: { 'x-access-token': this.token } });
        //     if (response.data.resources) {
        //         this.resources = response.data.resources.map(resource => {
        //             resource.community = resource.community.name;
        //             if (resource.roles === 'all_members') {
        //                 resource.roles = 'All Members';
        //             }
        //             return {
        //                 ...resource,
        //                 circle: this.shortToNameMap[resource.circle] || resource.circle
        //             };
        //         });
        //     }
        // } catch (error) {
        //     console.error('Error fetching resources:', error);
        //     if (error.response && error.response.status === 401) {
        //         localStorage.removeItem('authUser');
        //         this.$router.push('/login');
        //     }
        // }
    },
    displayLoading: function(value) {
    //   this.$isLoading = value;
      this.$nextTick(() => {
          var app = document.getElementsByClassName('app');
      });
    },
    resetFilters() {
      this.selectedCircle = 'all';
      this.circleId = null;
      this.circles = [];
      const currentDate = new Date();
      const startDate = lastNDaysStart(30, currentDate);
      this.selectedDates = { startDate: startDate, endDate: currentDate };
      this.defaultDateRange = 'last-30';
    },
    changeStatus: function() {
        this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/dashboard/users/${this.authUser._id}/update-priority-status`, {status: this.userData.download_report_priority}, {headers: {'x-access-token': this.token}}).then(response => {
        }).catch(err => {
            if (err.response.status === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
            }
        });
    },
    searchData: async function() {
        if (this.searchTxt) {
            if (this.searchTxt.length > 2) {
                let query = `q=${this.searchTxt}`;
                if (this.$route.params.community_id) {
                    query = `q=${this.searchTxt}&&community=${this.$route.params.community_id}`;
                }
                this.$router.push(`/dashboard/search?${query}`);
            } else {
                this.showErrorMsg();
            }
        }
    },
    handleBlur() {
        this.isBtnDisabled = true;
        for (const [key, value] of Object.entries(this.search)) {
            if (value && value.length >= 2 && key != 'community') {
                this.isBtnDisabled = false;
                break;
            }
        }
    },
    openAdvancedSearchModal: async function() {
        this.advancedSearchModal = true;
    },
    advancedSearch() {
        const qs = Object.keys(this.search).map(key => `${key}=${this.search[key]}`).join('&');
        if (this.$route.name == "Advanced Search Members") {
            this.$router.replace({query: this.search }).catch((err)=>{});
        } else {
            this.$router.push(`/engagement/members/advanced-search?${qs}`).catch((err)=>{});
        }
        this.advancedSearchModal = false;
    },
    clearSearch() {
        this.search = {};
        this.updateCommunityForAdvancedSearch();
        this.handleBlur();
    },
    updateCommunityForAdvancedSearch() {
        if (this.$route.params.community_id) {
            this.search.community = this.$route.params.community_id;
        } else {
            this.search.community = this.$route.query.community ? this.$route.query.community : null;
        }
    },
    handleUrlChange() {
      this.$nextTick(() => {
        const navDropdowns = document.querySelectorAll('.nav-item.nav-dropdown');
        navDropdowns.forEach(navDropdown => {
          const childElementWithClasses = navDropdown.querySelector('.router-link-exact-active.open');
          if (childElementWithClasses) {
            navDropdown.classList.add('open');
          }
            //   else {
            //     navDropdown.classList.remove('open');
            //   }
        });
        this.$helpers.setPaginationAnnouncement();
        this.$helpers.setLabelForSettingIcons();
        this.$helpers.setRoleButtonForSettingMenu();
      });
    },
    setNavItemsTabindex() {
        this.$nextTick(() => {
            const collapsibleNavItems = document.querySelectorAll(".nav-item.nav-dropdown");
            this.elements = collapsibleNavItems;
            const setTabIndex = (item) => {
                let firstChild = item.firstElementChild;
                firstChild.setAttribute("tabindex", "0");
                firstChild.setAttribute("role", "button");

                const childElements = item.querySelectorAll('a.nav-link');
                if (!item.classList.contains('open')) {
                    firstChild.setAttribute("aria-expanded", 'false');
                    childElements.forEach(child => {
                        child.setAttribute('tabindex', '-1');
                    });
                } else {
                    firstChild.setAttribute("aria-expanded", 'true');
                    childElements.forEach(child => {
                        child.setAttribute('tabindex', '0');
                    });
                }
            };
            collapsibleNavItems.forEach(item => setTabIndex(item));
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    setTabIndex(mutation.target);
                }
                });
            });
            collapsibleNavItems.forEach(item => {
                observer.observe(item, {
                attributes: true,
                attributeFilter: ['class']
                });
            });
        });
    },
    sanitizeInput(input) {
        return sanitizeInput(input);
    },
    sanitizeUrl(url) {
        return sanitizeUrl(url);
    },
    sanitizeHtmlTemplate(template) {
        return sanitizeHtmlTemplate(template);
    },
    sanitizeResourceDescription(description) {
        return sanitizeResourceDescription(description);
    },
    setAttributesToCswitch() {
        const Cswitch = document.querySelectorAll('.download-priority-report-switch .switch-slider');
        const keypressHandler = function(event) {
            if (event.key === "Enter") {
                const switchElement = event.target;
                this.userData.download_report_priority = !this.userData.download_report_priority;
                if (this.userData.download_report_priority) {
                    switchElement.setAttribute('aria-checked', 'true');
                } else {
                    switchElement.setAttribute('aria-checked', 'false');
                }
            }
        };

        for (let i = 0; i < Cswitch.length; i++) {
            const switchElement = Cswitch[i];
            switchElement.removeEventListener('keypress', switchElement.keypressHandler);
            const boundKeypressHandler = keypressHandler.bind(this);
            switchElement.addEventListener('keypress', boundKeypressHandler);
            switchElement.keypressHandler = boundKeypressHandler;
            switchElement.setAttribute('role', 'switch');
            switchElement.setAttribute('tabindex', '0');
            switchElement.setAttribute('aria-live', 'polite');

            if (this.userData.download_report_priority) {
                switchElement.setAttribute('aria-checked', 'true');
            } else {
                switchElement.setAttribute('aria-checked', 'false');
            }
        }
    },
    async handleCommunitySelection(communityId) {
        // Reset circles immediately to prevent cross-contamination
        this.selectedCircle = 'all';
        this.circles = [];
        
        this.selectedCommunity = communityId;
        localStorage.setItem('user_modal_option', communityId);
        localStorage.setItem('community_id', communityId);
 
        this.updateCommunityNameFromList(communityId);
        
        await this.loadSelectedCommunityData(communityId);

        // Navigation Logic to ensure view updates when community changes via modal
        if (communityId && communityId !== 'all') {
            if (this.$route.params.community_id !== communityId) {
                 this.$router.push({ name: 'Community Information', params: { community_id: communityId } }).catch(err => {});
            }
        } else {
            if (this.$route.name !== 'Dashboard') {
                this.$router.push({ name: 'Dashboard' }).catch(err => {});
            }
        }
    },
    
    updateCommunityNameFromList(communityId) {
        const community = this.communityList.find(c => c.communityId === communityId);
        if (community) {
            this.selectedCommunityName = community.communityName;
            localStorage.setItem('community_name', community.communityName);
        }
    },
    
    openWelcomeModal() {
        this.$root.$emit('show-welcome-modal', {
            selectedCommunity: this.selectedCommunity,
            communityList: this.communityList
        });
    },
    async loadSelectedCommunityData(communityId) {
        this.search = this.$route.query;
        this.updateCommunityForAdvancedSearch();
        this.handleBlur();
        
        let community = null;
        try {
            const response = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/communities/${communityId}`, {headers: {'x-access-token': this.token}});
            if (response.data) {
                community = response.data;
                this.allCommunities = [community];
                
                if (community.name) {
                    this.selectedCommunityName = community.name;
                    localStorage.setItem('community_name', community.name);
                    
                    this.syncCommunityNameInList(communityId, community.name);
                }
            }
        } catch (err) {
            console.error("Error fetching selected community details:", err);
            if (err.response && err.response.status === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
                return;
            }
            // Fallback to tenant list name if API fails
            this.updateCommunityNameFromList(communityId);
            console.log("Community details not available - using tenant data only");
        }

        await this.refreshRecruitingFlag(communityId);
        this.buildSidebarMenu(community);
        this.updateCircles(community);
        this.fetchUserProfile();
    },

    // Check core-api whether the current community has the Recruiting module
    // enabled. Result gates the "Opportunities" sidebar entry.
    async refreshRecruitingFlag(communityId) {
        this.recruitingEnabled = false;
        if (!communityId || communityId === 'all') return;
        const CORE_API_URL = process.env.VUE_APP_CORE_API_URL || 'http://localhost:8090';
        try {
            const { data } = await this.axios.get(
                `${CORE_API_URL}/api/recruiting/${communityId}`,
            );
            this.recruitingEnabled = data && data.enabled === true;
        } catch (err) {
            // Silent — treat missing recruiting config as "off".
            this.recruitingEnabled = false;
        }
    },
    
    syncCommunityNameInList(communityId, realName) {

        const index = this.communityList.findIndex(c => c.communityId === communityId);
        if (index !== -1 && this.communityList[index].communityName !== realName) {
            this.$set(this.communityList, index, {
                ...this.communityList[index],
                communityName: realName
            });

            this.buildSidebarMenu(null);
        }

        this.saveCommunityNameToCache(communityId, realName);
        
        this.$root.$emit('community-list-updated', [...this.communityList]);
    },
    
    saveCommunityNameToCache(communityId, realName) {
        let cache = {};
        try {
            cache = JSON.parse(localStorage.getItem('community_names_cache') || '{}');
        } catch (e) {
            cache = {};
        }
        cache[communityId] = realName;
        localStorage.setItem('community_names_cache', JSON.stringify(cache));
    },

    async fetchCommunityList() {
        try {
            const response = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/tenants`, { headers: { 'x-access-token': this.token } });
            if (response.data && response.data.data) {
                let allTenants = response.data.data
                    .map(t => ({ communityId: t.communityId, communityName: t.communityName }))
                    .sort((a, b) => a.communityName.localeCompare(b.communityName));

                if (this.authUser) {
                    const role = this.authUser.role ? this.authUser.role.toLowerCase() : '';
                    
                    if (role === 'superadmin') {
                        this.communityList = allTenants;
                    } else if (this.authUser.communities && this.authUser.communities.length > 0) {
                        this.communityList = allTenants.filter(t => this.authUser.communities.includes(t.communityId));
                    } else {
                        this.communityList = [];
                    }
                } else {
                    this.communityList = [];
                }

                if (this.selectedCommunity && this.selectedCommunity !== 'all') {
                    this.updateCommunityNameFromList(this.selectedCommunity);
                }

                // Auto-select if only one community is available
                if (this.communityList.length === 1) {
                    const singleCommunity = this.communityList[0];
                    this.selectedCommunity = singleCommunity.communityId;
                    this.selectedCommunityName = singleCommunity.communityName;
                    localStorage.setItem('user_modal_option', singleCommunity.communityId);
                    localStorage.setItem('community_id', singleCommunity.communityId);
                    localStorage.setItem('community_name', singleCommunity.communityName);
                    
                    // Load community data without triggering navigation
                    await this.loadSelectedCommunityData(singleCommunity.communityId);
                }
                
                this.buildSidebarMenu(null);
                
                // Share the community list with WelcomeModal
                this.$root.$emit('community-list-updated', this.communityList);
            }
        } catch (error) {
            console.error("Error fetching community list:", error);
        }
    },

    buildSidebarMenu(community) {
        // Base navigation items from _nav.js
        let baseNavItems = [...nav.items];
        
        // Create Community Nav Item (Accordion)
        let communityChildren = [];
        if (this.communityList && this.communityList.length > 0) {
            communityChildren = this.communityList.map(c => ({
                name: c.communityName,
                url: `/dashboard/communities/${c.communityId}`,
                icon: ''
            }));
        }

        let communityNavItem = { 
            name: 'Communities', 
            icon: 'icon-globe', 
            url: '#',
            children: communityChildren
        };

        // Create Settings Nav Item
        let settingsNavItem = null;
        if (this.authUser) {
             settingsNavItem = { 
                name: 'Settings', 
                icon: 'cui-cog',
                url: '#', 
                children: [
                    { name: 'Member Rank', url: '/reports/member-rank', icon: '' }, 
                    { name: 'Scoring Model', url: '/dashboard/engagement-score', icon: '' }, 
                    { name: 'Users', url: '/dashboard/users', icon: '' }
                ]
            };
        }

        const isSuperAdmin = this.authUser.role === 'SuperAdmin';

        let newNavItems = [];
        newNavItems.push(baseNavItems[0]); // Dashboard
        newNavItems.push(communityNavItem);
        newNavItems.push(baseNavItems[3]); // Engagement
        newNavItems.push(baseNavItems[4]); // Management
        newNavItems.push(baseNavItems[5]); // Members
        // SCRUM-645's SuperAdmin-only restriction is lifted — the Engagement Stream vs
        // Responses count discrepancy it was guarding against has been fixed.
        newNavItems.push(baseNavItems[1]); // Stream
        newNavItems.push(baseNavItems[2]); // Reports
        newNavItems.push(baseNavItems[8]); // Resources
        newNavItems.push(baseNavItems[6]); // Library
        newNavItems.push(baseNavItems[7]); // Uploads

        if (isSuperAdmin && settingsNavItem) {
          newNavItems.push(settingsNavItem);
        }

        this.navItems = this.applyRecruitingVisibility(newNavItems);
        this.setNavItemsTabindex();
    },

    // Hide recruiting-only entries when Recruiting is off for the community:
    // "Opportunities" (Engagement) and "Opportunity Approvals" (Management).
    applyRecruitingVisibility(items) {
        if (this.recruitingEnabled) return items;
        const hiddenChildByGroup = {
            Engagement: 'Opportunities',
            Management: 'Opportunity Approvals',
        };
        return items.map((item) => {
            if (!item || !Array.isArray(item.children)) return item;
            const hiddenChild = hiddenChildByGroup[item.name];
            if (!hiddenChild) return item;
            return {
                ...item,
                children: item.children.filter((child) => child && child.name !== hiddenChild),
            };
        });
    },

    updateCircles(community) {
        if (community) {
             this.selectedCircle = "all";
             this.circles = community.additionalParams || [];
             this.circles = this.circles
                .filter(circle => circle && circle.name)
                .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        } else {
            this.circles = [];
        }
    },

    fetchUserProfile() {
        this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/users/${this.authUser._id}/edit-profile`, {headers: {'x-access-token': this.token}}).then(response => {
            if(response.data.user) {
                this.userData = response.data.user;
                if (this.userData.role == 'SuperAdmin') {
                    this.isPriority = true;
                }
            }
        }).catch(err => {
             if (err.response && err.response.status === 401) {
                localStorage.removeItem('authUser');
                this.$router.push('/login');
            }
        });
    },

  }
}
</script>

<style>
.app.blurred {
    filter: blur(5px);
    pointer-events: none;
    user-select: none;
}
</style>